<template>
  <div class="network-container">
    <div v-if="display.bus || display.road || display.roadWorks || display.cycling || dynamicLayer" class="network-header" @click="displayContent = !displayContent">
      <a class="settings-icon">
        <i v-if="displayContent" class="tim-icons icon-simple-remove" ></i>
         <img v-else src="static/img/layers.png" />
      </a>
    </div>
    <div v-show="displayContent" class="network-content">
      <div v-if="display.bus" class="network-element-content-bus">
        <label>{{ $t('mapPage.networkTitle')}}</label>
        <el-select
          style="max-height:100px; overflow: auto;"
          v-model="lines"
          multiple
          :placeholder="$t('mapPage.networkLines')"
          popper-class="filters-project1"
        >
          <el-option-group
            v-for="group in options"
            :key="group.key"
            :label="group.label">
            <el-option
              v-for="item in group.options"
              :key="item.value"
              :label="item.label"
              :value="`${item.value}`">
            </el-option>
          </el-option-group>
        </el-select>
      </div>
      <div class="layers-header">
        <label>{{ $t('mapPage.dynamicLayers')}}</label>
        <button class="btn btn-icon btn-primary custom-btn" @click="layersExpanded = !layersExpanded">
          <i v-if="layersExpanded" class="tim-icons icon-simple-delete"></i>
          <i v-else class="tim-icons icon-simple-add"></i>
        </button>
      </div>

      <div :class="['layers-container', { 'is-expanded': layersExpanded }]">
        <div class="layers-inner-content">
          <div class="network-element-content">
            <label>{{ $t('mapPage.legend')}}</label>
            <div class="network-item">
              <base-switch v-model="legendEnable" on-text="ON" off-text="OFF" @input="onLegendEnable"></base-switch>
            </div>
          </div>
          <div class="divider-network"></div>
          <div v-for="(item, index) in layerToDisplay" :key="index">
            <div class="network-element-content">
              <label :title="item.label">{{ item.label }}</label>
              <div class="network-item">
                <base-switch v-model="item.value" on-text="ON" off-text="OFF" @input="onFlowSelect(item)"></base-switch>
              </div>
            </div>
            <div class="divider-network"></div>
          </div>
        </div>
        
        
      </div>
      <div style="height: 20px;"></div>
    </div>
  </div>
</template>
<script>
import {Select, Option, OptionGroup} from 'element-ui';
import { BaseSwitch } from 'src/components';
import RoadNetwork from './../shared/roadNetwork';
import axios from 'axios';


export default {
  name: 'network-component',
  props: {
    'flow' : {type : Object},
    'instance' : {type : Object},
    'isLegend' : {type : Boolean}
  },
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [OptionGroup.name]: OptionGroup,
    BaseSwitch
  },
  watch: {
    'lines'(lines) {
      this.$emit('drawBusLines', [lines]);
    }
  },
  data () {
    return {
      layerToDisplay: [],
      displayContent: false,
      options: [],
      lines: null,
      layersExpanded: false,
      dynamicLayer: false,
      legendEnable: false,
      display: {
        bus: true,
      }
    };
  },
  methods: {
    onFlowSelect(item){
      this.$emit('flowSelect', [item]);
    },
    onLegendEnable(value) {
      this.$emit('legendEnable', value);
    }
  },
  created() {
    let _this=this;
    let user = JSON.parse(window.localStorage.getItem('user'));
    let lang = user.lang || 'fr';
    let dynamicLayersKeys = Object.keys(RoadNetwork[this.instance.city].dynamicLayers);
    dynamicLayersKeys.forEach((key) => {
      _this.display[key]=RoadNetwork[_this.instance.city].dynamicLayers[key];
      if (_this.display[key]) {
        let label = lang === 'fr' ? _this.display[key].label_fr : _this.display[key].label_en;
        _this.layerToDisplay.push({'key': key, 'value': false, 'label': label});
      }
    });
    axios.get('layer/list').then(response => {
      let data = response.data;
      if (data.success && data.data) {
      this.dynamicLayer = true;
        let res =  data.data; 
        res.forEach((layer,key) =>{
          _this.display[key]=key;
          let label = lang === 'fr' ? layer.label_fr : layer.label_en;
          _this.layerToDisplay.push({'key': key, 'value': false, 'label': label});          
        });
      } 
      }).catch((e) => {
      console.error("Error fetching dynamic layer list:", e);
        _this.$notify({
          message: e.message,
          timeout:   10000,
          icon: 'tim-icons icon-bell-55',
          horizontalAlign: 'center',
          verticalAlign: 'top',
          type: 'danger'
        });
      });
    if(this.instance.city == 'magog'){
      _this.layerToDisplay.push({'key': 'addressLayer', 'value': false, 'label': 'Numéro d’adresse'});
      _this.layerToDisplay.push({'key': 'streetLayer', 'value': true, 'label': 'Réseau routier'});
    }

    this.display.bus = RoadNetwork[this.instance.city].bus;
    if (this.display.bus) {
      let lines = RoadNetwork[this.instance.city].bus.lines.map((line) => {
        if (line.value === 'Tout') {
          line.label= _this.$i18n.t('mapPage.networkLineAll');
        }
        return line;
      });
      this.options= [
        {key:'network1', label:'', options: lines}
      ];
    }
  }
}
</script>
<style>
  div.network-container {
    display: flex;
    justify-content: center;
    position: fixed;
    top: 25%;
    right: 15px;
    cursor: pointer;
    opacity: 1;
    z-index: 100;
  }
  div.network-container div.network-content {
    position: absolute;
    top: 50px;
    width: 300px;
    max-height: 450px;
    background-color:white;
    right: 2px;
    padding: 10px;
    border-radius: 4px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  }

  .layers-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 15px;
    margin-bottom: 10px;
  }

  .layers-container {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.2s ease-in-out;
  }

  .layers-container.is-expanded {
    max-height: 300px;
    overflow-y: auto;
  }

  .layers-inner-content {
    padding-top: 10px;
  }

  div.network-header {
    border-radius: 4px;
    border: 1px solid #ddd;
    box-shadow: 0 1px 4px -1px rgba(0,0,0,0.3);
    background: #fff;
    text-align: center;
    padding: 8px;
  }
  div.network-header a.settings-icon {
    height: 24px;
    width: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  div.network-header img {
    height: 20px;
    width: 20px;
  }
  
  div.network-content div.divider-network {
    border-bottom: 1px solid #eee;
    margin-top: 15px;
    margin-bottom: 15px;
  }
  div.network-content label {
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-right: 5px;
  }
  
  .filters-project1 .el-select-group__wrap:not(:last-of-type)::after {
    display: none;
  }
  .el-select-dropdown.el-popper.is-multiple.filters-project1 {
    min-width: auto !important;
  }
  .filters-project1 .el-select-dropdown.is-multiple .el-select-dropdown__item.selected::after {
    right: 0px !important;
  }
  .filters-project1 ul.el-select-group__wrap {
    border-right: 1px solid #e4e7ed;
    padding: 0 10px;
  }
  .filters-project1 ul.el-select-group li.el-select-dropdown__item.selected,
  .filters-project1 .el-select-dropdown.is-multiple .el-select-dropdown__item.selected {
    color: #e14eca !important;
  }
  div.network-element-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  div.network-element-content label {
    flex-grow: 1;
  }
  div.network-element-content div.network-item {
    flex-shrink: 0;
  }

  button.custom-btn {
    height: 1.5rem !important;
    min-width: 1.5rem !important;
    width: 1.5rem !important;
    font-size: .6rem !important;
    padding: 0 !important;
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>
